// src/lib/date.ts

/**
 * Formats a UTC date string into a user-friendly timestamp in the configured application timezone
 */
export function formatDateTime(
  dateString?: string | null,
  timezone = 'Asia/Kolkata'
): string {
  if (!dateString) return '—';

  try {
    // Append Z if missing to ensure UTC parsing
    const normalized = dateString.endsWith('Z') || dateString.includes('+') ? dateString : dateString.replace(' ', 'T') + 'Z';
    const date = new Date(normalized);

    if (isNaN(date.getTime())) {
      return dateString;
    }

    return new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    }).format(date);
  } catch (error) {
    return dateString;
  }
}

export function formatDateOnly(
  dateString?: string | null,
  timezone = 'Asia/Kolkata'
): string {
  if (!dateString) return '—';

  try {
    const normalized = dateString.endsWith('Z') || dateString.includes('+') ? dateString : dateString.replace(' ', 'T') + 'Z';
    const date = new Date(normalized);

    if (isNaN(date.getTime())) {
      return dateString;
    }

    return new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      year: 'numeric',
      month: 'short',
      day: '2-digit',
    }).format(date);
  } catch (error) {
    return dateString;
  }
}
